<template>
  <b-row>
    <b-col>
      <router-view />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard } from "bootstrap-vue";
export default {
  components: {
    BRow,
    BCol,
    BCard,
  },
  beforeDestroy() {
    if (this.$store.hasModule("UNCoop")) this.$store.unregisterModule("UNCoop");
  },
};
</script>
